/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React, { Component } from "react";
import { ComboBox, DropdownSkeleton } from "carbon-components-react";
import PropTypes from "prop-types";
import AuditRepository from "../../../helpers/api/AuditRepository";

export default class AuditorComboBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			items: [],
		};
		this.onChange = this.onChange.bind(this);
		this.repository = new AuditRepository();
	}

	async componentDidMount() {
		this.setState({ loading: true });
		const items = await this.getItems();
		this.setState({ items, loading: false });
	}

	onChange = (selectedItem) => {
		const item = selectedItem ? selectedItem.selectedItem : null;
		this.props.onChange(item);
	};

	getItems = async () => {
		let items = [];
		const itemsDivision = [];
		try {
			//items = this.props.userDivision || []; //B1_Audit_Module_Optimization
			items = await this.repository.getAuditors();
			//RITM0544059 aggiunta if per usare la stessa combobox per il filtro dove non serve confrontarlo con nessuna division
			if (this.props.division) {
				items = items.filter((el) => el.divisions.includes(this.props.division));
			}
			const uniqueTags = [];
			items.map((item) => {
				if (uniqueTags.indexOf(item.email) === -1) {
					uniqueTags.push(item.email);
					itemsDivision.push(item);
				}
			});
			items = itemsDivision;
			if (this.props.itemsToExclude) {
				items = items.filter((item) => {
					const deletedId = this.props.itemsToExclude.map((filter) => filter.id);
					const itemId = item.id;
					return !deletedId.includes(itemId);
				});
			}
		} catch (error) {
			console.error(error);
			this.props.onError(error);
		}
		return items;
	};

	render() {
		return this.state.loading ? (
			<DropdownSkeleton />
		) : (
			<ComboBox
				id="comboBoxAuditor"
				invalid={this.props.invalid}
				invalidText={this.props.invalidText}
				disabled={this.state.items < 1 || this.props.disabled}
				placeholder="Choose an Auditor"
				items={this.state.items}
				onChange={this.onChange}
				shouldFilterItem={({ item, inputValue }) => item.fullName?.toLowerCase().includes(inputValue.toLowerCase()) || item.email?.toLowerCase().includes(inputValue.toLowerCase())}
				itemToString={(item) => (item ? item && item.email && `${item.name}  ${item.surname} (${item.email})` : "")}
				selectedItem={this.props.selectedItem}
			/>
		);
	}
}

AuditorComboBox.propTypes = {
	invalid: PropTypes.bool,
	invalidText: PropTypes.string,
	division: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onError: PropTypes.func.isRequired,
	selectedItem: PropTypes.object,
	itemsToExclude: PropTypes.array,
	disabled: PropTypes.bool,
};
AuditorComboBox.defaultProps = {
	invalid: false,
	invalidText: "",
	selectedItem: null,
	itemsToExclude: null,
	disabled: true,
};
